import { Alert, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PropTypes from 'prop-types';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const theme = createTheme({
  palette: {
    success: {
        main: '#A7F0BA',
      },
    warning:{
        main: '#FFE17C',
    },
    error:{
        main: '#FF8389',
    },
    inform: {
      main: '#AAE3F9',
    }
  },
});

const getNotificationIcon = (status) => {
  switch (status) {
    case 'success':
      return <TaskAltIcon />;
    case 'warning':
      return <ErrorOutlineIcon />;
    default:
      return <HighlightOffIcon />;
  }
};

export const NotiStackProvider = ({ pageNotification }) => {
  const [notiOpen, setNotiOpen] = useState(false);

  useEffect(() => {
    if (pageNotification != null) {
      setNotiOpen(true);
    }
    return () => {
      setNotiOpen(false);
    };
  }, [pageNotification]);

  const handleClose = () => {
    setNotiOpen(false);
  };
  return (
    <>
      {pageNotification ? (
        <ThemeProvider theme={theme}>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={notiOpen}
          autoHideDuration={5000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            icon={getNotificationIcon(pageNotification.status)}
            color={pageNotification.status}
            variant="outlined"
            sx={{
              width: '100%',
              backgroundColor: '#000000',
              color: 'white',
              borderRadius: 0,
              minHeight:'56px',
              fontStyle:'normal',
              fontWeight:'400',
              fontSize:'14px',
              fontFamily:'lato'
            }}
          >
            {pageNotification.message}
          </Alert>
        </Snackbar>
        </ThemeProvider>
      ) : null}
    </>
  );
};
NotiStackProvider.propTypes = {
  pageNotification: PropTypes.object
};
export default NotiStackProvider;